const FilterType = {
    ASC: 'ASC',
    DESC: 'DESC',
    DATE_ASC: 'DATE_ASC',
    DATE_DESC: 'DATE_DESC',
};

export default FilterType;
